import _export from '../internals/export.js';
import objectIsExtensible from '../internals/object-is-extensible.js';

var $ = _export;
var $isExtensible = objectIsExtensible; // `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
// eslint-disable-next-line es/no-object-isextensible -- safe

$({
  target: 'Object',
  stat: true,
  forced: Object.isExtensible !== $isExtensible
}, {
  isExtensible: $isExtensible
});
